/**
 * Build a URL query string from a params object.
 * Undefined/null/empty-string values are silently skipped.
 *
 * @returns A string starting with '?' if any params exist, or '' if none.
 *
 * @example
 *   buildQueryString({ limit: 20, offset: 0, status: undefined })
 *   // => '?limit=20&offset=0'
 */
export function buildQueryString(
  params: Record<string, string | number | boolean | undefined | null>,
): string {
  const sp = new URLSearchParams()
  for (const [key, val] of Object.entries(params)) {
    if (val !== undefined && val !== null && val !== '') {
      sp.set(key, String(val))
    }
  }
  const str = sp.toString()
  return str ? `?${str}` : ''
}
